<template>
  <ul class="max-h-[300px] divide-y overflow-y-auto">
    <template v-if="isPendingShops">
      <li
        v-for="index in Array.from(Array(3).keys())"
        :key="index"
        class="flex h-10 flex-col justify-center space-y-4 px-4"
      >
        <Skeleton width="100%" />
      </li>
    </template>
    <li v-for="shop in shops" :key="shop.id" class="shop-item">
      <SettingShop
        :shop="shop"
        @click="handleClick(shop)"
      />
    </li>
  </ul>

  <SwitchShopDialog
    v-if="!!shopName"
    :shop-name="shopName"
    :visible="true"
  />
</template>

<script setup lang='ts'>
import Skeleton from 'primevue/skeleton';
import { ref } from 'vue';

import SettingShop from '@/modules/layout/components/atoms/SettingShop';
import SwitchShopDialog from '@/modules/layout/components/molecules/SwitchShopDialog';
import { useShops, useShopSwitchMutation } from '@/queries/shop';
import { type ShopResource } from '@/types/laravel';

const { data: shops, isPending: isPendingShops } = useShops();
const { mutate } = useShopSwitchMutation();

const shopName = ref<null|string>(null);

function handleClick(shop: ShopResource) {
  shopName.value = shop.name;

  mutate({
    shop_id: shop.id,
  }, {
    onSuccess: () => {
      window.location.reload();
    },
  });
}
</script>
